import script from "./VisualCandles.vue?vue&type=script&lang=js"
export * from "./VisualCandles.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__